export const CIDS = {
	ANALOG_TRANSISTORS_GROUP: 'atg',
	AUTOMOTIVE: 'au',
	BREAKDOWN_VOLTAGE_CES: 'vbc',
	BREAKDOWN_VOLTAGE_DSS: 'vbr',
	BREAKDOWN_VOLTAGE_GSS: 'vgsm',
	CHANNEL_POLARITY: 'chp',
	COLLECTOR_CURRENT: 'ic',
	COLLECTOR_EMITTER_VOLTAGE: 'vcm',
	CONFIGURATION: 'cnf',
	CONTINUES_COLLECTOR_CURRENT: 'ict',
	COPACKAGED_DIODE: 'cpd',
	DATASHEET: 'dsh',
	DRAIN_CURRENT: 'id',
	DRAIN_CURRENT_MIN: 'idmn',
	DRAIN_CURRENT_MAX: 'idmx',
	DESCRIPTION: 'des',
	EMITTER_BASE_VOLTAGE: 'veb',
	FIVE_VOLT_LOGIC: 'fvl',
	FORWARD_CURRENT_TRANSFER_RATIO_MIN: 'hfm',
	OPERATION_AMPLIFIER_GROUP: 'oag',
	GAIN_BANDWIDTH: 'gbw',
	OLD_GATE_CHARGE_FOR_VGS_10: 'qg1',
	GATE_CHARGE_TYP: 'qgtp',
	GATE_SOURCE_VOLTAGE_MAX: 'vgsm',
	GENERAL_PART_NUMBER: 'gpn', // Web Part Number (WPN)
	INPUT_REFERRED_VOLTAGE_NOISE_DENSITY: 'en',
	MAX_POWER: 'mxp',
	MAX_POWER_FAMILY: 'mxpf',
	MOSFET_CONFIGURATION: 'cnf',
	MOUNTING_TYPE: 'mt',
	NUMBER_OF_CHANNELS: 'ch',
	OLD_ON_DS_RESISTANCE_TYPICAL_FOR_VGS_10V: 'rd1',
	ON_DS_RESISTANCE_TYPICAL_FOR_25_DEGREES: 'rot25',
	ON_STATE_RESISTANCE: 'ro',
	OUTPUT_CURRENT: 'io',
	PACKAGE_TYPE: 'pckt',
	NEW_MOSFET_PACKAGE_TYPE: 'nmpckt',
	PART_NUMBER: 'pn', // Orderable Part Number (OPN)
	POLARITY: 'pol',
	POWER_CONVERSION: 'pwcv',
	POWER_DISSIPATION: 'pd',
	POWER_DISSIPATION_TM_MAX: 'ptx',
	PRICE: 'prc',
	QUALIFICATION: 'qf',
	MOSFET_TYPE: 'mtp',
	GATE_LEVEL: 'gl',
	SILICON_FAMILY: 'sif',
	QUIESCENT_CURRENT: 'iqt',
	RAIL_TO_RAIL: 'rtr',
	RANK: 'rank',
	RANK_WPN: 'rankWPN',
	PART_SUITABILITY: 'ps',
	RATED_VOLTAGE: 'rv',
	SATURATION_VOLTAGE: 'vcs',
	SLEW_RATE: 'sr',
	SWITCH_CONFIGURATION: 'swc',
	TECHNOLOGY: 'tch',
	TOPOLOGY: 'tpl',
	TRANSITION_FREQUENCY: 'ftm',
	TYPE_OF_GENERAL_PURPOSE: 'tpgp',
	TYPICAL_CURRENT_LIMIT_FOR_25_DEGREES: 'ilm25',
	INPUT_OFFSET_VOLTAGE: 'vos',
	V_I_ON_MIN: 'vinm',
	V_I_OFF_MAX: 'vifm',
	R1: 'r1',
	R2: 'r2',
	TYPICAL_ZENER_VOLTAGE: 'vz',
	REPETITIVE_REVERSE_VOLTAGE: 'vrrx',
	CONTINUES_FORWARD_CURRENT: 'ifa',
	FORWARD_CURRENT_SURGE_PEAK: 'ifs',
	DIODE_TYPE: 'dt',
	REVERSE_CURRENT_MAX: 'irx',
	FORWARD_VOLTAGE_MAX: 'vfmx',
	JUNCTION_CAPACITANCE_MAX: 'cjx',
	REVERSE_VOLTAGE_MIN: 'vrn',
	FORWARD_CURRENT_MAX: 'ifx',
	RF_DIODE: 'rfd',
	TYPE_OF_POWER_SWITCH: 'tops',
	DRIVE_SOURCE_CURRENT_TYP: 'dsoct',
	DRIVE_SINK_CURRENT_TYP: 'dsict',
	V_IN_MAX: 'vim',
	V_CLASS: 'vcl',
	V_CC_MAX: 'vccx',
	ISOLATION_TYPE: 'it',
	NUMBER_OF_OUTPUTS: 'noo',
	T_RES_TYP: 'trs',
	V_CC_MIN: 'vccn',
	V_IO_MAX: 'vio',
	I_CC_TYP: 'icc',
	CONTROL_MODE: 'cm',
	SWITCHING_FREQUENCY: 'fs',
	WEB_DESIGNER: 'wd',
	WD_TOPOLOGY: 'wdtop',
	V_IN_MIN: 'vin',
	OUTPUT_VOLTAGE_TYPE: 'ovt',
	V_OUT_APLICATION_ORIENTED: 'voapo',
	V_IN_TYP: 'vit',
	I_OUT_MAX: 'iox',
	SWITCHING_FREQUENCY_MAX: 'fx',
	PWM_LEVEL: 'pml',
	PRODUCT_FAMILY: 'pf',
	CURRENT_LIMIT: 'cl',
	EFUSE: 'efuse',
	FEATURE: 'feat',
	INPUT_LEVEL: 'ilv',
	OUTPUT_LEVEL: 'ol',
	F_OUT_TYP: 'fot',
	F_IN_TYP: 'fit',
	V_CC_TYP: 'vccp',
	SHUTTER_TYPE: 'st',
	MEGAPIXELS: 'mpx',
	PIXEL_SIZE: 'pxs',
	FRAME_RATE: 'fps',
	COLOR: 'clr',
	OUTPUT_INTERFACE: 'oi',
	OPTICAL_FORMAT_NUMBER: 'ofn',
	FILTER_AUTOSET: 'filterAutoset',
	SIMILAR_PARTS_FOR_WPN: 'simPartWpn',
	SIMILAR_PARTS_FOR_OPN: 'simPartOpn',
	SIMILAR_PARTS: 'simParts',
	RATED_CURRENT: 'rc',
	V_F_TYP: 'vft',
	PIM_TECHNOLOGY: 'pmt',
	APPLICATION: 'apl',
	ON_STATE_DS_RESISTANCE_TYP: 'rot',
	SPICE_LIVE_MODEL_SUPPORTED: 'slms',
	ELITE_PAIRING_STUDIO_SUPPORTED: 'epss',
	SIMULATIONS: 'sim',
	V_BR_TYP: 'vbrp',
	TOLERANCE: 'tre',
	I_R_MIN: 'irn',
	T_A_MIN: 'tm',
	T_A_MAX: 'tx',
	REF_TYPE: 'rtp',
	TOOLS: 'tos',
	CHANNELS: 'ch',
	I_O_MAX: 'iom',
	T_PD_MAX: 'tpdx',
	V_CCA_MAX: 'vccax',
	V_CCA_MIN: 'vccan',
	V_CCB_MAX: 'vccbx',
	V_CCB_MIN: 'vccbn',
	TYPE: 'tp',
	I_CC_MAX: 'icm',
	DATA_RATE: 'dr',
	INTERFACE: 'itft',
	NUMBER_OF_LINES: 'nol',
	DIRECTION: 'dir',
	V_RWM_MAX: 'vrwm',
	C_MAX: 'cx',
	PACKAGE_SIZE: 'psz',
	V_O_MAX: 'vox',
	CATEGORY: 'cat'
};

export const COLUMN_DISPLAY = {
	TRUE: 'true',
	FALSE: 'false',
	EXCLUDED: 'excluded'
};

export const ROWS_PER_PAGE = [25, 50, 100];

export const SORT_DIRECTIONS = {
	ASC: 'asc',
	DEST: 'desc'
};

export const TABLE_NAVIGATION_HEIGHT = 70;
export const TABLE_SCROLLBAR_HEIGHT = 12;
export const FLOATING_TABLE_HEADER_OFFSET = TABLE_NAVIGATION_HEIGHT + TABLE_SCROLLBAR_HEIGHT;
export const TABLE_MOBILE_BREAKPOINT = 959.95;
